import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg"; 
import aboutUs from "../../assets/images/about-us-img.png";
import { Link } from "react-router-dom";

const AboutUs = () => {
    document.title = "About | Gujarat State Allied and Healthcare Council";
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="wrappermain">
                <div
                    className="banner-image wrappermain"
                    style={{
                        backgroundImage: "url(" + Background_Member2 + ")",
                        backgroundSize: "fill",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        padding: "25px 0",
                    }}
                >
                    <div className="banner-inner-breadcrumb">
                        <div className="container">
                            <nav aria-label="breadcrumb">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={"/"}>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">About Us</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="about-us-wrapper p-t-60 p-b-60">
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                                <div className="about-img"><img src={aboutUs} className="img-fluid" alt="About Us" /></div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                                <div className="about-us-desc py-2">
                                    <h2 className="section-title">About Us</h2>
                                    <p>The Gujarat State Allied and Healthcare Council is being constituted under the National Commission for Allied and Healthcare Professions (NCAHP) Act, 2021. This council will be responsible for regulating and coordinating allied and healthcare professions within the state of Gujarat. It is established to exercise the powers granted to state governments under the NCAHP Act.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutUs;
